import { Question, QuestionTypeEnum } from '@/models/Question';

export function questionGenerator(question?: Partial<Question>): Question {
  return {
    id: 1,
    order: 1,
    type: QuestionTypeEnum.TEXT,
    identifier: 'question-1',
    title: 'Question 1',
    activity: 1,
    ...question,
  };
}
